import { render } from "./AlunoCadastro.vue?vue&type=template&id=573c7152&scoped=true"
import script from "./AlunoCadastro.vue?vue&type=script&lang=js"
export * from "./AlunoCadastro.vue?vue&type=script&lang=js"

import "./AlunoCadastro.vue?vue&type=style&index=0&id=573c7152&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573c7152"]])

export default __exports__